import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { IBoardCardAgingPanelButtonProps } from './types';
import { DETAILS_SECTION_CARD_AGING_PROPERTIES_BUTTON } from '../../constants';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';

export function CardAgingPanelButton ({
    indicatorBoolean,
    isEssentialFeature,
    onClick
}: IBoardCardAgingPanelButtonProps) {
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={subTab === EBoardSetting.CARD_AGING}
            title={DETAILS_SECTION_CARD_AGING_PROPERTIES_BUTTON}
            indicatorBoolean={indicatorBoolean}
            isEssentialFeature={isEssentialFeature}
            onClick={() => {
                setSubTab(EBoardSetting.CARD_AGING);
                onClick();
            }}
        />
    );
}
